import React from "react";

const Pay = () => {
  return (
    <div>
      <h1 className="text-center mt-12 font-semibold text-3xl">
        Payment system coming soon.
      </h1>
    </div>
  );
};

export default Pay;
